/**
 * Convert (possibly) HTML rich text to readable plain text, preserving line
 * breaks from block-level elements.
 *
 * Used where rich-text content (e.g. a requirement description authored in
 * TinyMCE) must be shown or diffed as readable text rather than raw markup
 * (T1.9 #1/#5). Deliberately does NOT use dangerouslySetInnerHTML — rendering
 * untrusted HTML directly was a prior XSS issue (ISSUES_LOG B4).
 *
 * @param {*} html
 * @returns {string}
 */
export function htmlToText(html) {
  if (html == null) return '';
  if (typeof html !== 'string') {
    try {
      return typeof html === 'object' ? JSON.stringify(html) : String(html);
    } catch {
      return String(html);
    }
  }
  // Fast path: nothing that looks like a tag or entity.
  if (!/[<&]/.test(html)) return html.trim();

  let s = html
    // Block-level boundaries and <br> become newlines so structure survives.
    .replace(/<\s*br\s*\/?\s*>/gi, '\n')
    .replace(/<\/\s*(p|div|li|h[1-6]|tr|blockquote|pre)\s*>/gi, '\n')
    // Drop all remaining tags.
    .replace(/<[^>]+>/g, '');

  // Decode HTML entities using the DOM when available (browser/jsdom).
  if (typeof document !== 'undefined') {
    const el = document.createElement('textarea');
    el.innerHTML = s;
    s = el.value;
  }

  return s
    .replace(/\r\n?/g, '\n')
    .replace(/[ \t]+\n/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
